<template>
    <div class="title">
        <div class="back-link-type-1" v-if="fromRegistry || (currentCompanyIndex !== null && mode !== 'new') || !!audience" @click.stop="navigateBack">
            <div class="p" v-if="fromRegistry">{{$t('views.companies.back_to_registry')}}</div>
            <div class="p" v-else-if="currentCompanyIndex !== null && this.mode !== 'new'">{{$t('views.companies.results_overview')}}</div>
            <div class="p" v-else-if="!!audience">{{$t('views.companies.audience_statistics')}}</div>
        </div>
        <h1 class="name" :class="{'highlight': currentCompanyIndex !== null }">{{ title }}</h1>
        <p class="description" v-if="currentCompanyIndex === null" v-html="description"></p>
        <PpCreditsManager v-if="mode !== 'prospects'" />
        <CompaniesMode v-if="showMode" />
    </div>
</template>

<script>
    import { mapActions, mapState } from 'pinia';
    import { useCompaniesStore } from '@/stores/companies';
    import { useAudienceStore } from '@/stores/audience';
    import CompaniesMode from '@/components/companies/CompaniesMode';
    import PpCreditsManager from '@/components/misc/PpCreditsManager';

    export default {
        name: 'CompaniesTitle',
        components: {
            CompaniesMode,
            PpCreditsManager
        },
        props: {
            showMode: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState(useCompaniesStore, ['mode', 'currentCompanyIndex']),
            ...mapState(useAudienceStore, ['audience']),
            fromRegistry() {
                return window?.history?.state?.back === this.$router.resolve({ name: 'company_register' }).path;
            },
            title() {
                return this.audience ?
                            this.mode === 'prospects' ? this.audience.name:
                            this.mode === 'new' ? this.audience.name : this.audience.name :
                        this.mode === 'prospects' ? this.$t('views.prospects.title') :
                        this.mode === 'new' ? this.$t('views.suspects.title') : this.$t('views.companies.title');
            },
            description() {
                return this.audience ?
                            this.mode === 'prospects' ? this.$t('views.audience_prospects.description') :
                            this.mode === 'new' ? this.$t('views.audience_suspects.description') : this.$t('views.audience_companies.description') :
                        this.mode === 'prospects' ? this.$t('views.prospects.description') :
                        this.mode === 'new' ? this.$t('views.suspects.description') : this.$t('views.companies.description');
            },
        },
        methods: {
            ...mapActions(useCompaniesStore, ['routeToMode']),
            navigateBack() {
                if (this.fromRegistry) {
                    this.$router.push({ name: 'company_register' });
                } else if (this.currentCompanyIndex !== null && this.mode !== 'new') {
                    this.routeToMode(this.mode);
                } else if (this.audience) {
                    this.$router.push({ name: 'audience', params: { id: this.audience.audience_id } });
                }
            }
        }
    }
</script>